import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '@ui-kit';
import { AdoptionPathTable } from '../components/AdoptionPathTable';
import { AdoptionChecklist } from '../components/AdoptionChecklist';
import { CurationBundlePicker } from '../components/CurationBundlePicker';
import { ManualQuickstart } from '../components/ManualQuickstart';
import { LocalInfraSection } from '../components/LocalInfraSection';
import { AccessRequestSteps } from '../components/AccessRequestSteps';
import { RemakeWalkthrough } from '../components/RemakeWalkthrough';
import { RelatedLinkCards } from '../components/RelatedLinkCards';

/**
 * #628 — 시작하기 안내 (`/getting-started`). ROLE_USER 이상 로그인 사용자 대상 온보딩 페이지
 * (biz-specs/getting-started-guide.md §6). 원래 4 섹션은 신규 BE 엔드포인트 0(전체 FE 정적
 * i18n) — #641 로 `CurationBundlePicker` 섹션이 추가되며 기존 `GET /showcase/modules`(재사용)
 * + 신규 `POST /catalog/module-source-bundles`(commonshowcase biz) 를 소비한다.
 * #660 으로 `AdoptionPathTable` 다음, `CurationBundlePicker` 앞에 `AdoptionChecklist`
 * (3경로 진행 체크리스트 · localStorage) 가 삽입되었다(§UAT-2026-07-09-R660 §R660-1).
 * #670 으로 `ManualQuickstart` 다음, `AccessRequestSteps` 앞에 `LocalInfraSection`
 * (브로커 6종 모듈→profile→로컬 접속 매핑)이 삽입되었다(§R670-3 §R670-8).
 */
export function GettingStartedPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div>
      <PageHeader
        title={t('gettingStartedGuide.page.title')}
        subtitle={t('gettingStartedGuide.page.subtitle')}
        breadcrumb={
          <span>
            {t('common.nav.home')} / {t('gettingStartedGuide.page.title')}
          </span>
        }
        actions={
          // #669 §R669-4 — dismiss 플래그를 무시하고 `_index` 에서 온디맨드 재시작
          <button
            type="button"
            onClick={() => navigate('/_index', { state: { startTour: true } })}
            style={{
              background: 'none',
              border: '1px solid var(--color-surface-border)',
              borderRadius: 'var(--radius-md)',
              padding: 'var(--spacing-2) var(--spacing-3)',
              fontSize: 'var(--font-size-sm)',
              color: 'var(--color-text-primary)',
              cursor: 'pointer',
              fontFamily: 'var(--font-family-sans)',
            }}
          >
            {t('gettingStartedGuide.tour.replay')}
          </button>
        }
      />
      <div
        style={{
          padding: 'var(--spacing-6)',
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--spacing-8)',
        }}
      >
        <AdoptionPathTable />
        <AdoptionChecklist />
        <CurationBundlePicker />
        <ManualQuickstart />
        <LocalInfraSection />
        <AccessRequestSteps />
        <RemakeWalkthrough />
        <RelatedLinkCards />
      </div>
    </div>
  );
}
